import {
  CLEAR_SELECTED_SEARCH_MEMBERS,
  REMOVE_SELECTED_SEARCH_MEMBER,
  SEARCH_USERS_FAILURE,
  SEARCH_USERS_REQUEST,
  SEARCH_USERS_SUCCESS,
  SET_SELECTED_SEARCH_MEMBERS,
} from "../../constants"

export function pendingTransactions(state = {}, action) {
  const cloneState = { ...state }
  switch (action.type) {
    case "SET_PENDING_TRANSACTIONS":
      const itemKey = Object.keys(action.payload)[0]
      const storedItem = cloneState[itemKey] || {}
      const updatedItem = {
        ...storedItem,
        ...Object.values(action.payload)[0],
      }
      return { ...cloneState, [itemKey]: updatedItem }
    case "CLEAR_PENDING_TRANSACTIONS":
      return {}
    case "REMOVE_PENDING_TRANSACTION":
      delete cloneState[action.id]
      return cloneState
    default:
      return state
  }
}
export function searchUsers(
  state = {
    results: [],
    loading: false,
    error: null,
    selected: [],
  },
  action,
) {
  switch (action.type) {
    case SEARCH_USERS_REQUEST:
      return { ...state, loading: true, error: null }
    case SEARCH_USERS_SUCCESS:
      return { ...state, loading: false, results: action.payload }
    case SEARCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.error, results: [] }
    case SET_SELECTED_SEARCH_MEMBERS:
      return { ...state, selected: action.payload }
    case CLEAR_SELECTED_SEARCH_MEMBERS:
      return { ...state, selected: [] }
    case REMOVE_SELECTED_SEARCH_MEMBER:
      return {
        ...state,
        selected: state.selected.filter((m) => m.id !== action.payload),
      }
    default:
      return state
  }
}
